import React, { Component } from "react";
import {
  PencilIcon,
  ClockIcon,
  InformationCircleIcon,
  DuplicateIcon,
} from "@heroicons/react/outline";
import { FiVideo } from "react-icons/fi";
import { Helmet } from "react-helmet";

import Header from "../Components/Header";
import Body, { Grid, Col } from "../Components/Body";
import Button from "../Components/Button";
import Output from "../Components/Output";
import Countdown from "react-countdown";
import { withRouter, NavLink,Link } from "react-router-dom";

import { observable, makeObservable, computed } from "mobx";
import { observer, inject } from "mobx-react";

import EntryTabs from "../Components/EntryTabs";
import EntryPrompt from "../Components/EntryPrompt";
import EntryInput from "../Components/EntryInput";
import EntryN from "../Components/EntryN";
import { TiThLargeOutline, TiCodeOutline, TiPen } from "react-icons/ti";
import { FiLogOut } from "react-icons/fi";
import { CiMoneyBill } from "react-icons/ci";
import Filter from "bad-words";
let filterBadWords = new Filter();

@inject("store")
@observer
class Tool extends Component {
  @observable tool = {};

  @observable.deep prompts = [];
  @observable currentPrompt = 0;
  @observable currentOption = "Start Using";

  @observable error = "";

  @observable output = "";
  @observable outputs = [];
  @observable code = "";

  @observable loading = false;

  @observable date = Date.now() + 1000;
  countdown = [];

  constructor(props) {
    super(props);
    makeObservable(this);
    this.tool = this.props.store.getToolByUrl(this.props.location.pathname);
    if (!this.tool) {
      window.location.href = "/";
    } else {
      this.prompts = [...this.tool.prompts];
    }
    this.state = {
      clicked: false,
      active: "",
      showModal: false
    };
  }

  handleCurrentPrompt = (val) => {
    this.currentPrompt = val;
  };

  @computed get isGenerateButtonDisabled() {
    if (this.loading) {
      return true;
    }

    return false;
  }

  @computed get disabled() {
    if (this.prompts[this.currentPrompt].prompts[0].value.length < 1) {
      return true;
    }

    // this.prompts[this.currentPrompt].prompts[promptIndex].value
    return false;
  }

  @computed get isMinLength() {
    if (!this.props.prompt.min) {
      return false;
    }
    if (!this.props.prompt.type === "number") {
      return false;
    }

    return false;
  }

  checkMinimumPrompts = () => {
    let shouldReturn = false;

    this.prompts[this.currentPrompt].prompts.forEach((prompt, promptIndex) => {
      if (prompt.min) {
        if (prompt.value.length < prompt.min) {
          shouldReturn = true;
          prompt.error = `${prompt.title} needs to meet the minimum ${prompt.min} characters`;
        }
      }
    });

    return shouldReturn;
  };

  clearExampleTimeout = [];

  onStartUsing = async () => {
    this.loading = false;
    this.error = "";
    this.clearExampleTimeout.forEach((item, index) => {
      clearTimeout(this.clearExampleTimeout[index]);
    });
    this.currentOption = "Start Using";
  };

  onExample = async () => {
    this.loading = true;
    this.error = "";
    this.output = "";
    this.outputs = [];
    this.code = ``;

    this.currentOption = "Example";

    let totalLength = 0;

    this.clearExampleTimeout.forEach((item, index) => {
      clearTimeout(this.clearExampleTimeout[index]);
    });

    this.prompts[this.currentPrompt].prompts.forEach((prompt, promptIndex) => {
      this.prompts[this.currentPrompt].prompts[promptIndex].value = "";
    });

    this.prompts[this.currentPrompt].prompts.forEach((prompt, promptIndex) => {
      for (
        let timeoutIndex = 0;
        timeoutIndex < prompt.example.length;
        timeoutIndex++
      ) {
        totalLength++;
        this.clearExampleTimeout[totalLength] = setTimeout(() => {
          this.prompts[this.currentPrompt].prompts[promptIndex].value +=
            prompt.example[timeoutIndex];
        }, 7 * totalLength);
      }
    });

    totalLength++;

    if (this.prompts[this.currentPrompt].example.output) {
      this.clearExampleTimeout[totalLength] = setTimeout(() => {
        this.output = this.prompts[this.currentPrompt].example.output;
        totalLength++;
        this.clearExampleTimeout[totalLength] = setTimeout(() => {
          this.loading = false;
          this.currentOption = "Start Using";
          this.prompts[this.currentPrompt].prompts[0].value += " ";
        }, 7 * totalLength + this.prompts[this.currentPrompt].example.output.length * 7 + 500);
      }, 7 * totalLength + 500);
    }

    if (this.prompts[this.currentPrompt].example.code) {
      totalLength++;
      this.clearExampleTimeout[totalLength] = setTimeout(() => {
        this.code = `${this.prompts[this.currentPrompt].example.code}`;
        this.loading = false;
      }, 7 * totalLength + 500);
    }

    if (this.prompts[this.currentPrompt].example.outputs) {
      this.clearExampleTimeout[totalLength] = setTimeout(() => {
        this.outputs = this.prompts[this.currentPrompt].example.outputs;

        totalLength++;
        this.clearExampleTimeout[totalLength] = setTimeout(() => {
          this.loading = false;
          this.currentOption = "Start Using";
          // this.prompts[this.currentPrompt].prompts[0].value += " "
        }, 7 * totalLength + 500);
      }, 7 * totalLength + 500);
    }
  };
  onVideo = async () => {
    this.currentOption = "Video Tutorial";
    this.state.showModal = true
    this.currentOption = "Start Using";

  };

  sanitizeAllPrompts = () => {
    this.prompts[this.currentPrompt].prompts.forEach((prompt) => {
      if (!prompt.value) {
        return false;
      }
      if (prompt.type === "number") {
        return false;
      }

      prompt.value = prompt.value.trim();

      if (filterBadWords.isProfane(prompt.value)) {
        prompt.error = "Unsafe content , please try different language";
        throw Error("Unsafe content");
      }
    });
  };

  contentFilterFlagged = async (response) => {
    this.error = response.message;

    this.date = Date.now() + 5000;
    this.countdown.forEach((countdown) => {
      if (countdown) {
        countdown.stop();
        countdown.start();
      }
    });
    this.loading = false;
  };

  checkOutput = (output) => {
    if (output) {
      output = output.replace(/^\s+|\s+$/g, "");
      // output = output.replace(/\s{2,}/g, ' ')
    }
    return output;
  };

  @computed get language() {
    let language = "";
    this.prompts[this.currentPrompt].prompts.forEach((prompt) => {
      if (prompt.attr === "language") {
        language = `${prompt.value}`;
      }
    });
    return language;
  }

  onGenerateClick = async () => {
    try {
      this.error = "";
      this.output = "";
      this.code = ``;
      this.outputs = [];
      this.loading = true;

      let checkMinimumPrompts = this.checkMinimumPrompts();
      if (checkMinimumPrompts) {
        this.loading = false;
        return false;
      }
      // this.sanitizeAllPrompts()

      let postObj = {};

      this.prompts[this.currentPrompt].prompts.forEach((prompt) => {
        postObj[prompt.attr] = prompt.value;
      });

      postObj.currentPrompt = this.prompts[this.currentPrompt].title;
      if (this.prompts[this.currentPrompt].n) {
        postObj.n = this.prompts[this.currentPrompt].n;
      }

      let response = await this.props.store.api.post(this.tool.api, postObj);

      if (!response.data.success) {
        this.contentFilterFlagged(response.data);
        return false;
      }

      if (response.data.output) {
        this.output = this.checkOutput(response.data.output);
      }

      if (response.data.code) {
        this.code = response.data.code;
      }

      if (response.data.outputs) {
        this.outputs = response.data.outputs;
      }

      this.date = Date.now() + 10000;
      this.countdown.forEach((countdown) => {
        if (countdown) {
          countdown.stop();
          countdown.start();
        }
      });
      this.loading = false;
    } catch (error) {
      console.log(error);
      this.countdown.forEach((countdown) => {
        if (countdown) {
          countdown.stop();
          countdown.start();
        }
      });
      this.loading = false;
    }
  };

  render() {
    // required for mobx to pick up deeply nested value
    const currentValue = this.prompts[this.currentPrompt].prompts[0].value;

    return (
      <>
        {this.state.showModal && (
          <>
            <div
              className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
            >
              <div className="relative w-auto my-6 mx-auto  max-w-xs sm:max-w-3xl">
                {/*content*/}
                <div className="bg-dark-5 border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                  {/*header*/}
                  <div className="flex items-start justify-between p-1 border-b border-solid border-slate-200 rounded-t">
                    {/* <h3 className="text-3xl font-semibold text-c-yellow">
                   Video Tutorial
                  </h3> */}
                    <button
                      className="p-1 ml-auto border-0 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                      onClick={() => this.setState({ showModal: !this.state.showModal })}
                    >
                      <span className="text-c-yellow h-6 w-6 text-2xl block outline-none focus:outline-none">
                        ×
                      </span>
                    </button>
                  </div>
                  {/*body*/}
                  <video src={this.tool.video} width="700" height="400" controls></video>
                  {/*footer*/}
                  {/* <div className="flex items-center justify-end p-6 border-t border-solid border-slate-200 rounded-b">
                  <button
                    className="bg-yellow-500  text-black background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                    type="button"
                    onClick={() => this.setState(!this.state.showModal)}
                  >
                    Close
                  </button>
                </div> */}
                </div>
              </div>
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
          </>
        )}
        <Helmet>
          <title>{`${this.tool.title} Tool - MealPalAI`}</title>
        </Helmet>
        <div class="w-full flex flex-col md:flex-row overflow-hidden h-screen-2 md:overflow-hidden ">

          <aside
            class="w-full hidden md:flex flex main_aside  md:w-1/5 h-screen-2 bg-dark-4 md:flex items-stretch flex-col md:overflow-hidden md:flex"
            aria-label="Sidebar"
          >
            <ul className="px-6 mt-0 block flex flex-col">
                     <Link to="/#MealPlanning" className="flex"  onClick={() => this.setState({ active: "Meal Planning" })}>
                <li
                 
                  className={`px-6 py-4 focus:bg-light-gray hover:bg-black border-radius-12 mb-2 text-grey-600 flex items-center text-c-gray hover:text-white cursor-pointer w-full ${
                    this.state.active === "Meal Planning" ? "active" : "inactive"
                  }`}
                >
                  <TiCodeOutline size="24" />{" "}
                  <span className="pl-3 font-size-20">Meal Planning</span>
                </li>
              </Link>
            </ul>
            <div className=" relative md:self-start mx-6 mb-3  w-full divider-center    divide-y divide-solid divide-gray-100 divide-opacity-30 md:mt-auto">
              {" "}
              <div></div>
              <div></div>
            </div>
            <NavLink
              onClick={() => this.setState({ active: 'pricing' })}
              to="/my-profile/pricing"
              className="relative  w-full md:w-80 mb-2 px-6 mx-6 py-4 focus:bg-light-gray hover:bg-black border-radius-12 text-white flex items-center hover:text-white cursor-pointer"
            >
              <CiMoneyBill size="24" />
              <span className="pl-3 font-size-20">Manage Plan</span>
            </NavLink>

            <div
              className="relative  w-full md:w-80 px-6 mx-6 py-4 focus:bg-light-gray hover:bg-black border-radius-12 text-white flex items-center hover:text-white cursor-pointer"
              onClick={this.props.store.handleLogout}
            >
              <FiLogOut size="24" />
              <span className="pl-3 font-size-20">Log out</span>
            </div>
          </aside>
          <div class="w-full md:w-4/5    bg-dark-6 h-screen-2 md:overflow-y-scroll styled-scrollbar">
            <Header
              title={this.tool.title}
              desc={this.tool.desc}
              Icon={this.tool.Icon}
              fromColor={this.tool.fromColor}
              category={this.tool.category}
              options={[
                {
                  title: "Start Using",
                  Icon: PencilIcon,
                  color: this.props.store.profile.credits ? "green" : "red",
                  onClick: this.onStartUsing,
                },
                {
                  title: "Example",
                  color: "yellow",
                  Icon: InformationCircleIcon,
                  onClick: this.onExample,
                },
                {
                  title: "Video Tutorial",
                  color: "yellow",
                  Icon: FiVideo,
                  onClick: this.onVideo,
                },
              ]}
              currentOption={this.currentOption}
            />
            <div className="flex flex-col md:flex-row">
              <div className="bg-dark-2 text-white md:px-4 w-full">
                <Body>
                  <Grid>
                    <Col span="6">
                      <EntryTabs
                        prompts={this.prompts}
                        currentPrompt={this.currentPrompt}
                        onChange={this.handleCurrentPrompt}
                      />

                      {this.prompts.map((prompt, index) => (
                        <EntryPrompt
                          prompt={prompt}
                          key={index}
                          index={index}
                          disabled={this.disabled}
                          currentPrompt={this.currentPrompt}
                        >
                          {prompt.prompts.map((promptInput, index) => (
                            <EntryInput
                              prompt={promptInput}
                              key={index}
                              language={this.language}
                              index={index}
                              disabled={this.disabled}
                            />
                          ))}

                          <div className="md:flex mb-4 sm:mb-0">
                            <Countdown
                              ref={(countdown) =>
                                (this.countdown[index] = countdown)
                              }
                              date={this.date}
                              renderer={(props) => (
                                <Button
                                  title={
                                    props.total
                                      ? `Please Wait ${props.total / 1000} secs`
                                      : "Submit"
                                  }
                                  disabled={
                                    this.props.store.profile.credits <= 0 || props.total || this.isGenerateButtonDisabled
                                  }
                                  Icon={
                                    props.total
                                      ? ClockIcon
                                      : currentValue
                                        ? DuplicateIcon
                                        : PencilIcon
                                  }
                                  onClick={this.onGenerateClick}
                                />
                              )}
                            />
                            <EntryN
                              prompts={this.prompts}
                              currentPrompt={this.currentPrompt}
                            />
                          </div>

                          {this.error && (
                            <div className="mt-4">
                              <label
                                className={`${this.error ? "text-red-400" : "text-gray-400"
                                  } font-medium transition-all`}
                              >
                                {this.error}
                              </label>
                            </div>
                          )}
                          {this.props.store.profile.credits <= 0 && (
                            <div className="mt-4">
                              <label
                                className='text-red-400 font-medium transition-all'
                              >
                                You have no words remaining so can't perform any requests. Head to Manage Plan to get more words.
                              </label>
                            </div>
                          )}
                        </EntryPrompt>
                      ))}
                    </Col>
                    <Col span="6">
                      <Output
                        title={this.tool.output.title}
                        desc={this.tool.output.desc}
                        Icon={this.tool.output.Icon || this.tool.Icon}
                        fromColor={this.tool.fromColor}
                        toColor={this.tool.toColor}
                        loading={this.loading}
                        output={this.output}
                        outputs={this.outputs}
                        code={this.code}
                        language={this.language}
                        outputsColor={this.tool.output.color}
                        OutputsIcon={this.tool.output.Icon}
                      />
                    </Col>
                  </Grid>
                </Body>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(Tool);